import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { loginByUsername, logout, getLoginUser, getUserMenu } from '@/api/login';
import { getToken, setToken, setRfleshToken, getRfleshToken, removeToken, getUserId, setUserId, removeUserId, getEntSerno, setEntSerno, removeEntSerno } from '@/utils/auth';
var user = {
  state: {
    user: '',
    status: '',
    code: '',
    userType: '',
    userPhone: '',
    userTheme: '',
    // 用户主题
    communityId: '',
    token: getToken(),
    refleshToken: getRfleshToken(),
    name: '',
    isSuper: '',
    roleId: '',
    avatar: '',
    introduction: '',
    buildId: '',
    nineRead: 0,
    // 90天
    userId: getUserId(),
    entSchool: getEntSerno(),
    menuTree: [],
    alarmData: [],
    isReal: '0',
    refreshInfo: {
      alarmRefresh: '0',
      cpcsRefresh: '0'
    },
    realFilter: null,
    setting: {
      articlePlatform: []
    }
  },
  mutations: {
    SET_CODE: function SET_CODE(state, code) {
      state.code = code;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_USERTYPE: function SET_USERTYPE(state, type) {
      state.userType = type;
    },
    SET_COMMUNITYID: function SET_COMMUNITYID(state, id) {
      state.communityId = id;
    },
    SET_USERPHONE: function SET_USERPHONE(state, phone) {
      state.userPhone = phone;
    },
    SET_USERTHEME: function SET_USERTHEME(state, theme) {
      state.userTheme = theme;
    },
    SET_REFLESHTOKEN: function SET_REFLESHTOKEN(state, refleshToken) {
      state.refleshToken = refleshToken;
    },
    SET_ENTSERNO: function SET_ENTSERNO(state, entSerno) {
      state.entSchool = entSerno;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
      state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
      state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
      state.status = status;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_ISSUPER: function SET_ISSUPER(state, isSuper) {
      state.isSuper = isSuper;
    },
    SET_ROLEID: function SET_ROLEID(state, roleId) {
      state.roleId = roleId;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_USER_ID: function SET_USER_ID(state, userId) {
      state.userId = userId;
    },
    SET_MENU: function SET_MENU(state, menuTree) {
      state.menuTree = menuTree;
    },
    SET_ALARM_DATA: function SET_ALARM_DATA(state, alarmData) {
      state.alarmData = alarmData;
    },
    SET_ISREAL: function SET_ISREAL(state, isReal) {
      state.isReal = isReal;
    },
    SET_REAL_FILTER: function SET_REAL_FILTER(state, realFilter) {
      state.realFilter = realFilter;
    },
    SET_AlARM_REFRESH: function SET_AlARM_REFRESH(state, isRefresh) {
      state.refreshInfo.alarmRefresh = isRefresh;
    },
    SET_CPCS_REFRESH: function SET_CPCS_REFRESH(state, isRefresh) {
      state.refreshInfo.cpcsRefresh = isRefresh;
    },
    SET_CPCS_REFRESHINFO: function SET_CPCS_REFRESHINFO(state, refreshInfo) {
      state.refreshInfo = refreshInfo;
    },
    SET_BUILD_ID: function SET_BUILD_ID(state, buildId) {
      state.buildId = buildId;
    },
    SET_NINETY_READ: function SET_NINETY_READ(state, nineRead) {
      state.nineRead = nineRead;
    }
  },
  actions: {
    // 用户名登录
    LoginByUsername: function LoginByUsername(_ref, userInfo) {
      var commit = _ref.commit;
      return new Promise(function (resolve, reject) {
        loginByUsername(userInfo.username, userInfo.password, userInfo.rememberMe, userInfo.timestamp, userInfo.validateCode, userInfo.uuid).then(function (response) {
          var data = response.data.data;
          commit('SET_TOKEN', data.access_token); // 新框架改动点 token->access-token

          setToken(data.access_token);
          commit('SET_REFLESHTOKEN', data.refresh_token); // 新框架改动点 token->access-token

          setRfleshToken(data.refresh_token); //  新框架改动点 获取用户信息不需要使用userid，直接请求就行

          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 获取用户信息
    GetUserInfo: function GetUserInfo(_ref2) {
      var commit = _ref2.commit;
      return new Promise(function (resolve, reject) {
        // 新框架改动点 获取用户信息
        getLoginUser().then(function (response) {
          var data = response.data.data;
          commit('SET_USERTYPE', data.userType);
          commit('SET_COMMUNITYID', data.communityId);
          commit('SET_USER_ID', data.userId);
          setUserId(data.userId);
          setEntSerno(data.userId);
          commit('SET_NAME', data.userName);
          commit('SET_ISSUPER', data.isSuper);
          commit('SET_ROLEID', data.userId);
          commit('SET_ENTSERNO', data.entSerno);
          commit('SET_USERTHEME', data.userTheme);
          commit('SET_USERPHONE', data.mobilephone); // 新框架改动点 获取动态菜单

          getUserMenu().then(function (response2) {
            var data = response2.data.data;
            commit('SET_MENU', data);
            resolve(response2);
          });
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 登出
    LogOut: function LogOut(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;
      return new Promise(function (resolve, reject) {
        logout(state.token).then(function () {
          commit('SET_TOKEN', '');
          commit('SET_REFLESHTOKEN', ''); // 新框架改动点 token->access-token

          commit('SET_MENU', []);
          removeToken();
          removeEntSerno();
          removeUserId();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 前端 登出
    FedLogOut: function FedLogOut(_ref4) {
      var commit = _ref4.commit;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', '');
        commit('SET_REFLESHTOKEN', ''); // 新框架改动点 token->access-token

        removeToken();
        resolve();
      });
    }
  }
};
export default user;